import React from 'react';
import { createPortal } from 'react-dom';
import { getWindow } from './getWindow';
export var PortalToBody = function PortalToBody(_ref) {
  var children = _ref.children,
      enablePortal = _ref.enablePortal;
  var win = getWindow();

  if (!win) {
    return null;
  }

  if (!enablePortal) {
    return React.createElement(React.Fragment, null, children);
  }

  return createPortal(children, win.document.getElementsByTagName('body')[0]);
};
PortalToBody.defaultProps = {
  enablePortal: true
};